<template>
  <v-app>
    <v-main>
      <v-container fill-height>
    <v-layout
      align-center
      text-center
      wrap
    >
      <v-flex align-content-start>
        <v-img
          :src="require('./assets/logo.png')"
          class="my-3"
          contain
          height="200"
        ></v-img>

 </v-flex>
    </v-layout>
  </v-container>

    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'App',

  components: {
  },

  data: () => ({
    //
  }),
};
</script>
